function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
/* eslint-disable max-classes-per-file */ import axiosStatic from 'axios';
import { axios } from 'api/axios';
import { getCurrentApiHost, API_NAMESPACE, API_VERSION } from 'config/environment';
class HttpClient {
    /**
   * this base url is used to generate download url
   * for project files.
   * these download urls will be set as href for anchor tags.
   */ // eslint-disable-next-line class-methods-use-this -- getter returns dynamic host, no instance state
    get BASEURL() {
        return `${getCurrentApiHost()}/${API_NAMESPACE}/${API_VERSION}`;
    }
    constructor(){
        _define_property(this, "_api", void 0);
        _define_property(this, "api", ()=>this._api);
        _define_property(this, "get", (url, config)=>{
            return this.api().get(url, config).then((x)=>x.data);
        });
        _define_property(this, "getResponse", (url, config)=>{
            return this.api().get(url, config).then((x)=>x);
        });
        _define_property(this, "post", (url, payload, config)=>this.api().post(url, payload, config).then((x)=>x.data));
        _define_property(this, "put", (url, payload, config)=>this.api().put(url, payload, config).then((x)=>x.data));
        _define_property(this, "patch", (url, payload, config)=>this.api().post(url, payload, config).then((x)=>x.data));
        _define_property(this, "delete", (url, config)=>this.api().delete(url, config).then((x)=>x.data));
        this._api = axiosStatic.create({
            baseURL: this.BASEURL
        });
        axios().subscribe((client)=>{
            this._api = client;
        });
    }
}
export { HttpClient };
export var ApprovalType = /*#__PURE__*/ function(ApprovalType) {
    ApprovalType["TaskApproval"] = "TASK";
    ApprovalType["SpaceTabApproval"] = "SPACE_TAB";
    ApprovalType["InvoiceApproval"] = "INVOICE";
    return ApprovalType;
}({});
class HomeHttpClient extends HttpClient {
    async getCsatAndApprovalsCount(companyIds) {
        return this.get(`/home/action-items/aggregated-counts?companyIds=${companyIds}`);
    }
    async getHomeScreenResponse() {
        return this.get('/home');
    }
    async getCsat(companyId) {
        return this.get(`/home/get-csat${companyId ? `?companyId=${companyId}` : ''}`);
    }
    async getMyCompanyTasks() {
        return this.get('/home/my-company-tasks');
    }
    async getAllApprovals() {
        return this.get('/home/pending-approvals');
    }
}
export const HomeAPI = new HomeHttpClient();
